import React, { useEffect } from 'react';
import { Translation } from 'react-i18next';

import ResourceAdminForm from '../containers/ResourceAdminFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';
import {
  MixpanelTracker,
  mixpanelEventsEnum,
} from '../../../../../lib/Mixpanel';

const ResourceAdminEditScreen = ({ history, role, ...props }) => {
  const scrollToTop = () => {
    Logger.log('debug', `ResourceAdminEditScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  };
  const trackerActions = (eventMixpanel, params = {}) => {
    if (role !== 1) {
      MixpanelTracker.mixpanelTrack(eventMixpanel, {
        partnershipName: props.partnershipName ?? 'No partnership',
        partnershipId: props.partnershipId ?? 'No partnership',
        ...params,
      });
    }
  };

  useEffect(() => {
    scrollToTop();
    trackerActions(
      mixpanelEventsEnum.ACTIONS_PARTNER.RESOURCES_ADMIN_EDIT_SCREEN
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Translation>
      {(t) => (
        <div>
          <DocumentHead title={t('resources_route_edit')} />
          <ResourceAdminForm
            id={props.match.params.id}
            history={history}
            trackerActions={trackerActions}
          />
        </div>
      )}
    </Translation>
  );
};

export default ResourceAdminEditScreen;

Logger.log('silly', `ResourceAdminEditScreen loaded.`);
